import styled from "styled-components";
import { PageContainer } from "views/components/pages/PharmacyAI/layout";
import Heading from "views/components/shared/Heading";

const VIGILION_LOGO_SRC = `${process.env.PUBLIC_URL}/images/vigilion-logo.png`;

const PageWrapper = styled.div`
  min-height: 70vh;
  padding: 8rem 0 4rem;
`;

const Content = styled.div`
  text-align: center;
`;

const VigilionLogo = styled.img`
  display: block;
  width: min(240px, 70vw);
  height: auto;
  margin: 0 auto 1.5rem;
`;

const ComingSoonText = styled.p`
  font-family: "SatoshiRegular", sans-serif;
  font-size: clamp(1.25rem, 3vw, 1.75rem);
  color: #666;
  margin-top: 1rem;
`;

const Cybersecurity = () => {
  return (
    <PageWrapper>
      <PageContainer>
        <Content>
          <VigilionLogo
            src={VIGILION_LOGO_SRC}
            alt="Vigilion Cybersecurity"
          />
          <Heading level={1} className="h2l">
            Cybersecurity
          </Heading>
          <ComingSoonText>Coming soon…</ComingSoonText>
        </Content>
      </PageContainer>
    </PageWrapper>
  );
};

export default Cybersecurity;
